import { render, staticRenderFns } from "./SectionBenefits.vue?vue&type=template&id=9bfbd3e2&scoped=true&"
import script from "./SectionBenefits.vue?vue&type=script&lang=js&"
export * from "./SectionBenefits.vue?vue&type=script&lang=js&"
import style0 from "./SectionBenefits.vue?vue&type=style&index=0&id=9bfbd3e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bfbd3e2",
  null
  
)

export default component.exports